import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
import Footer from '../VerticalLayout/Footer';
import axios from 'axios'
import React, { useEffect, useCallback, useMemo, useState } from "react";
import * as url from "../../api/uri_helper";
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Log from "../Authentication/Login";
import Index from "../Dashboard/Index";
import { getCompnaysitedata } from "../../Redux/Actions/DashboardCount";
import { fetchUserDataByEmailId } from "../../Redux/Api/fetch.api";
import { GET_VALIDATE_TOKEN } from "../../api/uri_helper";
import { Skeleton } from 'antd';



const Auth = () => {

    const history = useHistory();
    const location = useLocation();
    const { token, CompanyId, SiteId } = useParams();
    const searchParams = new URLSearchParams(location.search);
    const accesstoken = searchParams.get('accesstoken');
    const region = searchParams.get('region');
    const [encryptedToken, setEncryptedToken] = useState('');
    const [userName, setUsername] = useState('');
    const [isChecked, setisActive] = useState(true)
    const dispatch = useDispatch();
    const [isSuccess, setIsSuccess] = useState(false)
    const [siteId, setSiteId] = useState('');

    useEffect(() => {
        if (token && CompanyId && SiteId) {

            const decodedEmail = atob(token);
            const decodedCompanyID = atob(CompanyId);
            const decodedSiteID = atob(SiteId);
            setSiteId(decodedSiteID);
            RedirectToDashboard(decodedCompanyID, decodedSiteID, decodedEmail, accesstoken, region);
            getUserByEmailId(decodedEmail);
        } else {
            console.error('Invalid URL format');
        }
    }, []);

    const getUserByEmailId = (emailid) => {

        fetchUserDataByEmailId(emailid)
            .then(response => {

                if (response.data.success) {
                    const { firstName, lastName } = response.data.data;
                    localStorage.setItem('userName', `${firstName} ${lastName}`);

                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })

    }

    const RedirectToDashboard = async (
        companyID,
        siteID,
        emailID,
        accessToken,
        regionValue
    ) => {
        try {
            setEncryptedToken(accessToken);

            localStorage.setItem('ComingTekaverse', companyID);
            localStorage.setItem('SiteId', siteID);
            localStorage.setItem('emailid', emailID);

            if (accessToken) {
                localStorage.setItem('tekaHelpToken', accessToken);
                localStorage.setItem('accessToken', accessToken);
            }

            if (regionValue) {
                localStorage.setItem('region', regionValue);
            }

            // Validate access token
            const response = await axios.post(
                GET_VALIDATE_TOKEN,
                {
                    emailId: emailID,
                    siteId: siteID
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        ...(regionValue
                            ? { 'X-Region': regionValue }
                            : {})
                    }
                }
            );
            
            if (response.data.success) {

                setIsSuccess(true);

                // Get UserId from validation response
                localStorage.setItem(
                    'UserId',
                    response.data.data.userId
                );

                // If API returns a token, store it
                if (response.data.data.token) {
                    localStorage.setItem(
                        'tekaHelpToken',
                        response.data.data.token
                    );
                }

                localStorage.setItem(
                    'isChecked',
                    isChecked ? isChecked : ''
                );

                history.push({
                    pathname: "/QR",
                    state: {
                        from: location.pathname,
                        isRedirected: true,
                    },
                });

            } else {

                history.push({
                    pathname: "/VersionUpdate",
                    state: {
                        from: location.pathname,
                    },
                });
            }

        } catch (err) {
            console.log("RedirectToDashboard Error:", err);


        }
    };

    return (
        <>
            {isSuccess ? <Index /> : <Skeleton active avatar />}
        </>
    )

};
export default connect()(Auth)
